export const travellerProfile = state => state.travellerProfile
export const nationalities = state => state.nationalities
export const countries = state => state.countries
export const transportsInformation = state => state.transportsInformation
export const tagsConditions = state => state.tagsConditions
export const interests = state => state.interests
export const companions = state => state.companions
export const provisoryData = state => state.provisoryData
